import { parseJson } from './utils';

export default {
  setItem(key, val) {
    try {
      localStorage.setItem(key, val);
    } catch (e) { /*ignore*/ }
  },

  getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) { /*ignore*/ }
  },

  removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) { /*ignore*/ }
  },

  s_setItem(key, val) {
    try {
      sessionStorage.setItem(key, val);
    } catch (e) { /*ignore*/ }
  },

  s_getItem(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) { /*ignore*/ }
  },

  s_removeItem(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (e) { /*ignore*/ }
  },

  setOfficeId(officeId) {
    this.setItem('officeId', officeId);
    this.s_setItem('officeId', officeId);
  },

  getOfficeId() {
    return this.s_getItem('officeId') || this.getItem('officeId');
  },

  setApiKey(apiKey) {
    const officeId = this.getOfficeId();
    this.setItem(`apiKey_${officeId}`, apiKey);
    this.s_setItem(`apiKey_${officeId}`, apiKey);
  },

  getApiKey() {
    const officeId = this.getOfficeId();
    return this.s_getItem(`apiKey_${officeId}`) || this.getItem(`apiKey_${officeId}`);
  },

  setHwKey(hwKey) {
    this.s_setItem('hwKey', hwKey);
  },

  getHwKey() {
    return this.s_getItem('hwKey');
  },

  setMode(mode) {
    this.s_setItem('mode', mode);
  },

  getMode() {
    return this.s_getItem('mode');
  },

  isMain() {
    return this.getMode() === 'main';
  },

  isSub() {
    return this.getMode() === 'sub';
  },

  isNoVp() {
    return this.getMode() === 'noVp';
  },

  getLocalSetting() {
    const setting = this.getItem(`localSetting_${this.getOfficeId()}`);
    return parseJson(setting, {});
  },

  getLocalSettingOwner(ownerId) {
    const setting = this.getItem(`localSetting_${ownerId}`);
    return parseJson(setting, {});
  },

  setLocalSetting(setting) {
    this.setItem(`localSetting_${this.getOfficeId()}`, typeof setting == 'string' ? setting : JSON.stringify(setting));
  },

  setLocalSettingOwner(ownerId, setting) {
    this.setItem(`localSetting_${ownerId}`, typeof setting == 'string' ? setting : JSON.stringify(setting));
  },

  getOwnerOid() {
    return this.getItem('ownerOid');
  },

  setOwnerOid(officeId) {
    this.setItem('ownerOid', officeId);
  },

  getVpSetting() {
    return parseJson(this.getItem('vpSetting'), { vbCallStateSkipTime: 30, vbLoginAuto: '' });
  },

  setVpSetting(setting) {
    this.setItem('vpSetting', typeof setting == 'string' ? setting : JSON.stringify(setting));
  },

  getVp2Setting() {
    return parseJson(this.getItem('vp2Setting'), {});
  },

  setVp2Setting(setting) {
    this.setItem('vp2Setting', typeof setting == 'string' ? setting : JSON.stringify(setting));
  },

  setVpType(type) {
    this.s_setItem('vpType', type);
  },

  getVpType() {
    return this.s_getItem('vpType');
  },

  setHimeSelect1(select) {
    this.s_setItem('himeSelect1', select);
  },

  getHimeSelect1() {
    return this.s_getItem('himeSelect1');
  },

  setHimeSelect2(select) {
    this.s_setItem('himeSelect2', select);
  },

  getHimeSelect2() {
    return this.s_getItem('himeSelect2');
  },

  setDriverSelect1(select) {
    this.s_setItem('driverSelect1', select);
  },

  getDriverSelect1() {
    return this.s_getItem('driverSelect1');
  },

  setDriverSelect2(select) {
    this.s_setItem('driverSelect2', select);
  },

  getDriverSelect2() {
    return this.s_getItem('driverSelect2');
  },

  setDriverSelect3(select) {
    this.s_setItem('driverSelect3', select);
  },

  getDriverSelect3() {
    return this.s_getItem('driverSelect3');
  },

  setDriverSelect4(select) {
    this.s_setItem('driverSelect4', select);
  },

  getDriverSelect4() {
    return this.s_getItem('driverSelect4');
  },

  // 利用履歴の同一事業所チェック
  // 仕様変更に備えて、0 と 1 を使う
  setResvOfficeFilter(value) {
    this.setItem('resvOfficeFilter', value);
  },

  getResvOfficeFilter() {
    return this.getItem('resvOfficeFilter');
  },

  setUrcHistoryType(value) {
    const officeId = this.getOfficeId() || 'default';
    this.setItem(`urcHistoryType_${officeId}`, value);
  },

  getUrcHistoryType() {
    const officeId = this.getOfficeId() || 'default';
    return this.getItem(`urcHistoryType_${officeId}`);
  },

  removeOwnerLogin() {
    try {
      document.cookie = 'ownerLogin=; path=/; max-age=0';
    } catch (error) { /**/ }
  },

  setOwnerLogin(data) {
    try {
      document.cookie = `ownerLogin=${data}; path=/`;
    } catch (error) { /**/ }
  },

  isOwnerLogin(data) {
    try {
      const obj = Object.fromEntries(document.cookie.split('; ').map(v => v.split(/=(.*)/s).map(decodeURIComponent)));
      return obj['ownerLogin'] != null && obj['ownerLogin'] != data;
    } catch (error) {
      return false;
    }
  },
};
